import {createAsyncThunk} from "@reduxjs/toolkit"

export const setAverts = createAsyncThunk("/setAverts",async (data) => data)